export class CalculateColumnWidth {
    private wrapperWidth = 1320;
    private sidebarWidth = 332;
    private minDesktopWidth = 516;
    private lowerWidthMobile = 760;

    constructor() {
        this.calculateColumnWidth();

        window.addEventListener('debouncedResize', () => {
            this.calculateColumnWidth();
        });
    }

    calculateColumnWidth() {
        const wrappers: NodeListOf<HTMLElement> = document.querySelectorAll('[data-wrapper]');

        wrappers.forEach((wrapper) => {
            const hasColLeft = !!wrapper.querySelector('[data-col="left"]');
            const hasColRight = !!wrapper.querySelector('[data-col="right"]');
            const sideBarWidth = (hasColLeft ? this.sidebarWidth : 0) + (hasColRight ? this.sidebarWidth : 0);

            let width = Math.min(window.innerWidth - sideBarWidth, this.wrapperWidth - sideBarWidth);

            if (width < this.minDesktopWidth) {
                width = Math.min(window.innerWidth, this.lowerWidthMobile);
            }

            wrapper.style.setProperty('--main-col-width', `${width.toString()}px`);
        });
    }
}